import { jsxs as h, Fragment as x, jsx as e } from "react/jsx-runtime";
import { useRef as c } from "react";
import { CheckDoubleFillIcon as de, CloseLineIcon as me, ArrowUpSmallFillIcon as fe, ArrowDownSmallFillIcon as he } from "@ifrc-go/icons";
import { b as Ce } from "../../core-DVmjA3_O.js";
import { _ as E } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import C from "../Button/index.js";
import ge from "../InputContainer/index.js";
import ye from "../List/index.js";
import Ie from "../Popup/index.js";
import Me from "../RawInput/index.js";
import we from "../../hooks/useBlurEffect.js";
import Se from "../../hooks/useKeyboard.js";
import _e from "../../hooks/useTranslation.js";
import { extractInputContainerProps as Pe } from "../../utils/inputs.js";
import be from "./GenericOption/index.js";
import '../../index92.css';const ke = "common", Fe = { infoMessageAnd: "and", infoMessageMore: "more", buttonTitleSelect: "Select all", buttonTitleClear: "Clear", buttonTitleClose: "Close", buttonTitleOpen: "Open", selectInputPendingMessage: "Fetching options...", selectInputEmptyMessage: "No option available", selectInputFilteredMessage: "No option available for the search", selectInputErrorMessage: "Could not load options" }, Re = {
  namespace: ke,
  strings: Fe
}, Te = "_popup_ysmcd_1", Ne = "_list_ysmcd_6", De = "_list-item_ysmcd_12", Oe = "_info-message_ysmcd_17", ve = "_icon_ysmcd_24", t = {
  popup: Te,
  list: Ne,
  listItem: De,
  infoMessage: Oe,
  icon: ve
}, xe = [];
function Ye(K) {
  const {
    actions: V,
    disabled: l,
    readOnly: r,
    required: A,
    ...B
  } = K, [L, W] = Pe(
    B
  ), {
    name: g,
    onOptionClick: $,
    searchText: j,
    onSearchTextChange: H,
    optionContainerClassName: q,
    optionKeySelector: y,
    optionRenderer: G,
    optionRendererParams: U,
    options: z,
    optionsPopupClassName: J,
    persistentOptionPopup: I,
    placeholder: Q,
    valueDisplay: p = "",
    nonClearable: X,
    onClearButtonClick: Y,
    onSelectAllButtonClick: M,
    optionsPending: w = !1,
    optionsFiltered: Z = !1,
    optionsErrored: S = !1,
    focused: ee,
    focusedKey: _,
    onFocusedKeyChange: P,
    onFocusedChange: b,
    dropdownShown: s,
    onDropdownShownChange: a,
    totalOptionsCount: k = 0,
    hasValue: oe,
    autoFocus: ne,
    onEnterWithoutOption: te,
    dropdownHidden: se,
    withoutDropdownIcon: ie
  } = W, u = z ?? xe, o = _e(Re), F = c(null), R = c(null), d = c(null), T = c(null), re = (n) => {
    s || a(!0), H(n);
  }, le = (n, i) => {
    i.stopPropagation(), a(!s);
  }, N = () => {
    s || a(!0);
  }, m = () => {
    a(!1);
  }, ae = () => {
    r || N();
  }, ce = (n, i) => {
    n || i ? I && d.current && d.current.focus() : m();
  }, D = (n, i) => {
    $(n, i, g), I || m();
  }, pe = (n, i) => ({
    contentRendererParam: U,
    option: i,
    optionKey: n,
    focusedKey: _,
    contentRenderer: G,
    onClick: D,
    onFocus: P,
    optionContainerClassName: E(q, t.listItem)
  });
  we(
    s,
    ce,
    T,
    F
  );
  const ue = Se(
    _,
    y,
    u,
    s,
    P,
    m,
    N,
    D,
    te
  ), O = u.length, v = k - O > 0 ? `${o.infoMessageAnd} ${k - O} ${o.infoMessageMore}` : void 0, f = s && !se;
  return /* @__PURE__ */ h(x, { children: [
    /* @__PURE__ */ e(
      ge,
      {
        ...L,
        containerRef: F,
        inputSectionRef: R,
        disabled: l,
        readOnly: r,
        required: A,
        actions: /* @__PURE__ */ h(x, { children: [
          V,
          !r && M && /* @__PURE__ */ e(
            C,
            {
              onClick: M,
              disabled: l,
              colorVariant: "text",
              styleVariant: "action",
              name: void 0,
              title: o.buttonTitleSelect,
              children: /* @__PURE__ */ e(de, { className: t.icon })
            }
          ),
          !r && !X && oe && /* @__PURE__ */ e(
            C,
            {
              onClick: Y,
              disabled: l,
              colorVariant: "text",
              styleVariant: "action",
              name: void 0,
              title: o.buttonTitleClear,
              children: /* @__PURE__ */ e(me, { className: t.icon })
            }
          ),
          !r && !ie && /* @__PURE__ */ e(
            C,
            {
              onClick: le,
              colorVariant: "text",
              styleVariant: "action",
              name: void 0,
              disabled: l,
              title: f ? o.buttonTitleClose : o.buttonTitleOpen,
              children: f ? /* @__PURE__ */ e(fe, { className: t.icon }) : /* @__PURE__ */ e(he, { className: t.icon })
            }
          )
        ] }),
        input: /* @__PURE__ */ e(
          Me,
          {
            name: g,
            elementRef: d,
            readOnly: r,
            disabled: l,
            value: s || ee ? j : p,
            onChange: re,
            onClick: ae,
            onFocus: () => b(!0),
            onBlur: () => b(!1),
            placeholder: Ce(p) ? p : Q,
            autoComplete: "off",
            onKeyDown: ue,
            autoFocus: ne
          }
        )
      }
    ),
    f && /* @__PURE__ */ h(
      Ie,
      {
        elementRef: T,
        parentRef: R,
        className: E(J, t.popup),
        children: [
          /* @__PURE__ */ e(
            ye,
            {
              className: t.list,
              data: u,
              keySelector: y,
              renderer: be,
              rendererParams: pe,
              errored: S,
              filtered: Z,
              pending: w,
              pendingMessage: o.selectInputPendingMessage,
              emptyMessage: o.selectInputEmptyMessage,
              filteredEmptyMessage: o.selectInputFilteredMessage,
              errorMessage: o.selectInputErrorMessage,
              compact: !0
            }
          ),
          !w && !S && !!v && /* @__PURE__ */ e("div", { className: t.infoMessage, children: v })
        ]
      }
    )
  ] });
}
export {
  Ye as default
};
